var _defs, _path, _path2, _g, _g2, _polygon, _polygon2, _path3, _path4, _rect, _path5, _path6, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g3, _g4, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _g5, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _circle4, _path7, _path8, _path9, _path10, _path11, _rect33, _path12, _path13, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _path14, _ellipse, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandcoding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f8190e5e-7eb0-4b3f-adbf-15a0d430e3a9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fe9b49f8-e166-4e47-ac65-a2d5a59265ce"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b1f04b0c-412f-4f15-bef7-21759d12595e",
    "data-name": "SVGID",
    d: "M734.19,333.45c-6.71,56.78-32.6,122.79-84.4,153.12-78.23,45.82-71.69,116.3-224.38,147a313.33,313.33,0,0,1-67.69,6.39,260.44,260.44,0,0,1-33.24-2.72c-97-14.18-162.34-81.63-186.3-163C106.7,367,169.62,297,211.36,254.71S283.64,80.85,433.51,49.62A304.56,304.56,0,0,1,503.09,43c53.32,1.36,111.48,18.82,151.72,55.36q4.56,4.08,8.83,8.52C719.57,164.25,743.34,256.05,734.19,333.45Z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M734.19,333.45c-6.71,56.78-32.6,122.79-84.4,153.12-78.23,45.82-71.69,116.3-224.38,147a313.33,313.33,0,0,1-67.69,6.39,260.44,260.44,0,0,1-33.24-2.72c-97-14.18-162.34-81.63-186.3-163C106.7,367,169.62,297,211.36,254.71S283.64,80.85,433.51,49.62A304.56,304.56,0,0,1,503.09,43c53.32,1.36,111.48,18.82,151.72,55.36q4.56,4.08,8.83,8.52C719.57,164.25,743.34,256.05,734.19,333.45Z",
    fill: "#878e99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M734.19,333.45c-6.71,56.78-32.6,122.79-84.4,153.12-78.23,45.82-71.69,116.3-224.38,147a313.33,313.33,0,0,1-67.69,6.39,260.44,260.44,0,0,1-33.24-2.72c-97-14.18-162.34-81.63-186.3-163C106.7,367,169.62,297,211.36,254.71S283.64,80.85,433.51,49.62A304.56,304.56,0,0,1,503.09,43c53.32,1.36,111.48,18.82,151.72,55.36q4.56,4.08,8.83,8.52C719.57,164.25,743.34,256.05,734.19,333.45Z",
    fill: "#fff",
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eaf174e0-ebbb-4b42-a98f-45f9edbc98ad",
    "data-name": "freepik--Table--inject-546"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.39,420.64H678.88a.68.68,0,0,1,0-1.36h18.51a.68.68,0,0,1,0,1.36Z",
    fill: "#28d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.62,420.64H141.88a.68.68,0,0,1,0-1.36H670.62a.68.68,0,0,1,0,1.36Z",
    fill: "#28d3d3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e6f31740-1334-4c1a-b3b9-32a2fdb0f816",
    "data-name": "freepik--Gears--inject-546"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.06,302.44H632.24l-1.47-10.33a37.46,37.46,0,0,1-13.58-5.67l-8.31,6.23-8.35-8.35,6.26-8.34a37.5,37.5,0,0,1-5.6-13.58l-10.28-1.48V249.11l10.32-1.48a37.58,37.58,0,0,1,5.68-13.58l-6.23-8.31,8.35-8.35,8.34,6.26a37.32,37.32,0,0,1,13.58-5.6l1.48-10.28h11.8l1.49,10.32a37.3,37.3,0,0,1,13.58,5.68l8.31-6.23,8.35,8.35-6.26,8.34a37.08,37.08,0,0,1,5.6,13.58l10.28,1.47v11.81l-10.32,1.48a37.63,37.63,0,0,1-5.68,13.59l6.23,8.31-8.35,8.35-8.31-6.29a37.32,37.32,0,0,1-13.58,5.6Zm-10.64-1.36h9.51L644.37,291l.49-.09a36,36,0,0,0,13.92-5.74l.41-.28,8.15,6.14,6.68-6.7-6.11-8.15.28-.39a36.11,36.11,0,0,0,5.83-14l.08-.48,10.2-1.45V250.4L674.22,249l-.09-.48a35.91,35.91,0,0,0-5.73-14l-.27-.41,6.12-8.15-6.68-6.68-8.15,6.11-.41-.28a36,36,0,0,0-14-5.83l-.47-.08-1.51-10.07h-9.51l-1.44,10.08-.47.1a35.8,35.8,0,0,0-14,5.73l-.41.27-8.15-6.12-6.68,6.68,6.11,8.15-.27.4a36,36,0,0,0-5.83,13.95l-.09.48-10.12,1.45v9.51l10.08,1.44.09.47a35.85,35.85,0,0,0,5.84,14l.27.4-6.14,8.15,6.7,6.69,8.15-6.12.39.28a35.73,35.73,0,0,0,13.95,5.82l.48.1Zm4.84-19.55a26.46,26.46,0,1,1,26.46-26.45A26.46,26.46,0,0,1,638.26,281.53Zm0-51.54a25.1,25.1,0,1,0,25.1,25.1h0A25.12,25.12,0,0,0,638.26,230Z",
    fill: "#28d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.33,354.13h-8.77l-1.06-7.42a26.88,26.88,0,0,1-9.51-4l-6,4.48-6.21-6.2,4.5-6a26.53,26.53,0,0,1-3.93-9.5L647,324.44V315.6l7.41-1.06a26.78,26.78,0,0,1,4-9.51l-4.47-6,6.21-6.21,6,4.49a26.74,26.74,0,0,1,9.51-3.92L676.7,286h8.77l1.06,7.42a26.93,26.93,0,0,1,9.51,4l6-4.47,6.21,6.2-4.5,6a26.65,26.65,0,0,1,3.93,9.51l7.39,1.06v8.84l-7.42,1.06a26.78,26.78,0,0,1-4,9.51l4.47,6L702,347.31l-6-4.49a27.18,27.18,0,0,1-9.51,3.92Zm-7.6-1.36h6.44l1-7.18.49-.1a25.57,25.57,0,0,0,9.92-4.07l.41-.27,5.82,4.37,4.54-4.55-4.35-5.8.27-.41a25.57,25.57,0,0,0,4.15-9.9l.08-.47,7.21-1v-6.42l-7.18-1-.09-.48a25.68,25.68,0,0,0-4.07-9.93l-.27-.4,4.36-5.82L702,294.68,696.15,299l-.41-.27a25.59,25.59,0,0,0-9.89-4.15l-.49-.08-1-7.21H677.9l-1,7.19-.49.09a25.27,25.27,0,0,0-9.92,4.07l-.41.28-5.85-4.27-4.54,4.55L660,305l-.27.41a25.4,25.4,0,0,0-4.14,9.9l-.08.48-7.22,1v6.35l7.19,1,.08.47a25.62,25.62,0,0,0,4.07,9.93l.28.39-4.36,5.83,4.53,4.55,5.82-4.36.39.29a25.7,25.7,0,0,0,9.9,4.07l.49.1Zm3.3-13.58a19.11,19.11,0,1,1,19.11-19.11A19.11,19.11,0,0,1,681,339.19Zm0-36.86a17.75,17.75,0,1,0,17.75,17.75A17.75,17.75,0,0,0,681,302.33Z",
    fill: "#28d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,366.92H214.1l-1.36-9.42a34.1,34.1,0,0,1-12.34-5.16L192.81,358l-7.69-7.66,5.7-7.62a34.58,34.58,0,0,1-5.08-12.37L176.36,329V318.15l9.42-1.36A34.24,34.24,0,0,1,191,304.46l-5.7-7.59,7.69-7.7,7.62,5.72A34.19,34.19,0,0,1,213,289.78l1.36-9.4h10.87l1.36,9.44A33.86,33.86,0,0,1,238.92,295l7.59-5.69,7.7,7.7-5.72,7.62A34,34,0,0,1,253.57,317l9.4,1.36v10.86l-9.51,1.36a34.1,34.1,0,0,1-5.14,12.35l5.69,7.59-7.7,7.69-7.62-5.71a33.85,33.85,0,0,1-12.38,5.08Zm-9.7-1.35h8.6l1.36-9.2.49-.08a32.76,32.76,0,0,0,12.74-5.23l.39-.27,7.46,5.58,6-6-5.57-7.42.27-.41a32.84,32.84,0,0,0,5.31-12.72l.1-.47,9.22-1.36v-8.51l-9.2-1.36-.09-.49a32.85,32.85,0,0,0-5.23-12.74l-.27-.4,5.59-7.45-6-6L239,296.56l-.4-.28a33.13,33.13,0,0,0-12.7-5.31l-.48-.08-1.36-9.23h-8.61l-1.36,9.19-.47.1a32.7,32.7,0,0,0-12.74,5.23l-.41.27-7.46-5.6-6,6,5.57,7.43-.29.41a32.74,32.74,0,0,0-5.3,12.7l-.09.47-9.22,1.36v8.53l9.19,1.36.08.47a32.94,32.94,0,0,0,5.23,12.74l.27.41-5.58,7.46,6,6,7.43-5.57.39.28a32.67,32.67,0,0,0,12.72,5.3l.47.09Zm4.36-17.66a24.21,24.21,0,1,1,24.19-24.22v0a24.23,24.23,0,0,1-24.19,24.15Zm0-47a22.85,22.85,0,1,0,22.83,22.85v0a22.85,22.85,0,0,0-22.83-22.89h0Z",
    fill: "#28d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,295.58h-7.1l-.83-5.8a21.14,21.14,0,0,1-7.28-3l-4.67,3.5-5-5.07,3.5-4.68a21,21,0,0,1-3-7.3l-5.77-.82v-7.11l5.78-.83a21.52,21.52,0,0,1,3.05-7.28l-3.49-4.57,5-5,4.68,3.52a21.17,21.17,0,0,1,7.31-3l.83-5.77h7.09l.83,5.79a21,21,0,0,1,7.28,3l4.62-3.55,5,5-3.51,4.68a21.34,21.34,0,0,1,3,7.3l5.77.83v7.09l-5.8.82a21.32,21.32,0,0,1-3,7.3l3.49,4.66-4.93,5-4.69-3.52a21.39,21.39,0,0,1-7.31,3Zm-5.92-1.36h4.74l.79-5.57.49-.09a20,20,0,0,0,7.66-3.14l.4-.29,4.51,3.4,3.36-3.36-3.37-4.49.27-.41a19.58,19.58,0,0,0,3.19-7.65l.1-.47,5.59-.8v-4.74l-5.58-.8-.08-.48a19.66,19.66,0,0,0-3.15-7.67l-.27-.41,3.38-4.51-3.36-3.35-4.49,3.38-.41-.29a19.73,19.73,0,0,0-7.65-3.19l-.47-.09-.8-5.59H176.7l-.79,5.57-.49.1a19.79,19.79,0,0,0-7.66,3.13l-.41.28-4.51-3.39-3.35,3.36,3.37,4.49-.27.41a19.66,19.66,0,0,0-3.2,7.65l-.09.47-5.58.81v4.74l5.57.8.08.47a19.76,19.76,0,0,0,3.15,7.68l.27.39-3.38,4.52,3.34,3.36,4.49-3.38.41.28a19.43,19.43,0,0,0,7.65,3.19l.47.08Zm2.46-10.28A15,15,0,1,1,194,268.84v0A15.05,15.05,0,0,1,179.05,283.94Zm0-28.65A13.67,13.67,0,1,0,192.63,269v-.16A13.7,13.7,0,0,0,179.05,255.29Z",
    fill: "#28d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.26,198.41H412l-1.12-7.92a28.54,28.54,0,0,1-10.24-4.28L394.22,191l-6.59-6.59,4.81-6.4a28.39,28.39,0,0,1-4.23-10.25l-7.88-1.13v-9.32l7.88-1.17a28.67,28.67,0,0,1,4.27-10.24l-4.77-6.37,6.61-6.48,6.4,4.8A28.62,28.62,0,0,1,411,133.64l1.13-7.89h9.3l1.13,7.92a28.52,28.52,0,0,1,10.24,4.27l6.37-4.89,6.59,6.58L441,146a28.58,28.58,0,0,1,4.21,10.26l7.88,1.13v9.3l-7.92,1.15a28.66,28.66,0,0,1-4.26,10.22l4.78,6.39-6.59,6.57-6.4-4.79a28.55,28.55,0,0,1-10.27,4.21Zm-8.15-1.36h6.94l1.1-7.68.49-.09a27.39,27.39,0,0,0,10.62-4.37l.41-.27,6.23,4.67,5-4.92-4.65-6.2.28-.41A27.2,27.2,0,0,0,444,167.19l.1-.48,7.7-1.1v-7L444,157.5l-.1-.47a27.31,27.31,0,0,0-4.36-10.64l-.27-.41,4.62-6.13L439,134.93l-6.21,4.66-.4-.29a27.65,27.65,0,0,0-10.6-4.43l-.49-.08-1.1-7.71h-6.94l-1.1,7.69-.49.08A27.5,27.5,0,0,0,401,139.21l-.4.28-6.24-4.67-4.82,4.88,4.65,6.22-.28.39a27.59,27.59,0,0,0-4.42,10.61l-.1.47-7.7,1.1v7l7.67,1.1.1.47a27.31,27.31,0,0,0,4.36,10.64l.27.39-4.67,6.24,4.91,4.91,6.21-4.66.41.28a27.13,27.13,0,0,0,10.59,4.42l.49.1Zm3.62-14.62a20.38,20.38,0,1,1,20.38-20.38h0A20.38,20.38,0,0,1,416.73,182.43Zm0-39.39a19,19,0,1,0,19,19,19,19,0,0,0-19-19h0Z",
    fill: "#28d3d3"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "627.81 504.5 438.32 504.5 436.47 502.65 435.46 501.65 374.76 501.65 374.15 502.65 372.67 505.05 182.33 505.05 258.51 419.97 551.25 419.96 627.81 504.5",
    fill: "#878e99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "627.81 504.5 438.32 504.5 436.47 502.65 435.46 501.65 374.76 501.65 374.15 502.65 372.67 505.05 182.33 505.05 258.51 419.97 551.25 419.96 627.81 504.5",
    fill: "#fff",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.34,505v5.42A3.56,3.56,0,0,0,185.9,514H622.75a5.05,5.05,0,0,0,5.06-5v-4.46H438.32l-2.86-2.86H374.77l-2.1,3.39Z",
    fill: "#28d3d3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.22,227.82H546.85a4.71,4.71,0,0,1,4.71,4.71V420a0,0,0,0,1,0,0h-293a0,0,0,0,1,0,0V232.54A4.71,4.71,0,0,1,263.22,227.82Z",
    fill: "#28d3d3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 263.96,
    y: 239.03,
    width: 282,
    height: 174.62,
    rx: 1.14,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M528.22,247.62V400.16a2.78,2.78,0,0,1-2.79,2.79H284.62a2.78,2.78,0,0,1-2.78-2.79V247.62a2.78,2.78,0,0,1,2.78-2.77H525.43A2.79,2.79,0,0,1,528.22,247.62Z",
    fill: "#878e99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M528.22,247.62v6.67H281.84v-6.67a2.78,2.78,0,0,1,2.78-2.77H525.43A2.79,2.79,0,0,1,528.22,247.62Z",
    fill: "#fff",
    opacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 285.89,
    cy: 249.14,
    r: 1.63,
    fill: "#878e99"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.31,
    cy: 249.14,
    r: 1.63,
    fill: "#28d3d3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.17,
    cy: 249.14,
    r: 1.63,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 264.88,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 312.33,
    y: 264.88,
    width: 8.75,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 300.11,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 312.33,
    y: 300.11,
    width: 8.75,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 311.73,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 323.56,
    y: 311.73,
    width: 12.22,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 323.9,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 316.7,
    y: 323.9,
    width: 12.22,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 370.91,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.7,
    y: 370.91,
    width: 12.22,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 382.56,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.7,
    y: 382.56,
    width: 12.22,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 394.93,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 312.31,
    y: 394.93,
    width: 8.84,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 335.34,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 316.7,
    y: 335.34,
    width: 12.22,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 331.67,
    y: 335.34,
    width: 36.46,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 371.19,
    y: 335.34,
    width: 36.46,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 410.72,
    y: 335.34,
    width: 19.14,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 347.5,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.7,
    y: 347.5,
    width: 12.22,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.67,
    y: 347.5,
    width: 36.46,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.19,
    y: 347.5,
    width: 36.46,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.72,
    y: 347.5,
    width: 19.14,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 358.75,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 316.7,
    y: 358.75,
    width: 12.22,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 331.67,
    y: 358.75,
    width: 36.46,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 371.19,
    y: 358.75,
    width: 36.46,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 410.72,
    y: 358.75,
    width: 19.14,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 323.42,
    y: 264.88,
    width: 70.02,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 276.35,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 317.87,
    y: 276.35,
    width: 11.37,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 413.43,
    y: 276.35,
    width: 16.43,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 432.88,
    y: 276.35,
    width: 40.08,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 331.67,
    y: 276.35,
    width: 79.04,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 302.64,
    y: 288.5,
    width: 6.1,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 317.87,
    y: 288.5,
    width: 11.37,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 413.43,
    y: 288.5,
    width: 16.43,
    height: 6.1,
    rx: 0.28,
    fill: "#fff",
    opacity: 0.75
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 432.88,
    y: 288.5,
    width: 40.08,
    height: 6.1,
    rx: 0.28,
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 331.67,
    y: 288.5,
    width: 79.04,
    height: 6.1,
    rx: 0.28,
    fill: "#28d3d3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.11,
    cy: 233.98,
    r: 2.94,
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M689.58,397.06v90.12a4.09,4.09,0,0,1-4.1,4.07H631.9a4.08,4.08,0,0,1-4.09-4.07V397.06h.48c2.55,1.46,15.21,2.58,30.41,2.58s27.85-1.12,30.4-2.58Z",
    fill: "#878e99"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M689.58,408.52v78.66a4.09,4.09,0,0,1-4.1,4.07H631.9a4.08,4.08,0,0,1-4.09-4.07v-3.66c8.67,1.2,38.06,3.59,50.9-17.24a32.41,32.41,0,0,0,2.61-5.4C684,453.89,689.56,436.24,689.58,408.52Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M690.41,408.52a7.58,7.58,0,0,0-.83,0V420a7.58,7.58,0,0,1,.83,0c10.3,0,18.67,8.74,18.67,19.5S700.71,459,690.41,459c-.29,0-.55,0-.83,0V470.4c.28,0,.54,0,.83,0,16.36,0,29.63-13.85,29.63-31S706.77,408.52,690.41,408.52Z",
    fill: "#878e99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M689.58,408.55V420s5.37-.13,8.42,1.67V409.55A33.25,33.25,0,0,0,689.58,408.55Z",
    fill: "#fff",
    opacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M689.58,458.94V470.4s5.4.07,8.62-1.06l-.65-11.86A18,18,0,0,1,689.58,458.94Z",
    fill: "#fff",
    opacity: 0.4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 642.64,
    y: 399.24,
    width: 2.18,
    height: 31.33,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M482.13,502.65H436.47l-1-1h-60.7l-.61,1H327.4a1.33,1.33,0,0,1-1.2-1.81l11.39-30.07,135.46.07,10.3,30A1.32,1.32,0,0,1,482.13,502.65Z",
    fill: "#fff",
    opacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M635.88,443v-9a3,3,0,0,1,1.09-2.31l6.21-5.14a.89.89,0,0,1,1.11,0l6.8,5.38a3,3,0,0,1,1.14,2.36V443a1.2,1.2,0,0,1-1.2,1.2H637.08A1.2,1.2,0,0,1,635.88,443Z",
    fill: "#28d3d3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 337.26,
    y1: 430.77,
    x2: 473.45,
    y2: 430.77,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 352.94,
    y1: 437.65,
    x2: 457.77,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 358.94,
    y1: 444.04,
    x2: 451.77,
    y2: 444.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 325.3,
    y1: 452.63,
    x2: 485.42,
    y2: 452.63,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 355.76,
    y1: 461.7,
    x2: 455.07,
    y2: 461.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 328.27,
    y1: 460.35,
    x2: 333.63,
    y2: 445.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 354.17,
    y1: 430.77,
    x2: 348.07,
    y2: 452.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 360.73,
    y1: 437.65,
    x2: 359.79,
    y2: 444.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 368.58,
    y1: 430.77,
    x2: 367.35,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 366.06,
    y1: 444.04,
    x2: 364.53,
    y2: 452.63,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 381.18,
    y1: 452.63,
    x2: 382,
    y2: 444.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 375.85,
    y1: 437.65,
    x2: 375.14,
    y2: 444.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 383.72,
    y1: 430.77,
    x2: 383.36,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 399.12,
    y1: 431.07,
    x2: 398.77,
    y2: 437.96,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 391.46,
    y1: 437.65,
    x2: 391.46,
    y2: 444.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 407.24,
    y1: 437.65,
    x2: 407.24,
    y2: 444.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 398.11,
    y1: 444.04,
    x2: 398.11,
    y2: 452.63,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 415.06,
    y1: 444.04,
    x2: 415.06,
    y2: 452.63,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 431.04,
    y1: 444.04,
    x2: 431.04,
    y2: 452.63,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 446.28,
    y1: 444.16,
    x2: 447.78,
    y2: 461.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 463.54,
    y1: 444.47,
    x2: 465.99,
    y2: 461.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 479.29,
    y1: 444.24,
    x2: 483.43,
    y2: 461.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 423.38,
    y1: 444.04,
    x2: 422.88,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 438.7,
    y1: 437.65,
    x2: 439.7,
    y2: 444.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 414.22,
    y1: 430.77,
    x2: 414.22,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 429.16,
    y1: 430.77,
    x2: 429.16,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 444.49,
    y1: 430.77,
    x2: 444.49,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 459.27,
    y1: 430.77,
    x2: 459.27,
    y2: 437.65,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M689.58,396.52c0,.17-.16.37-.48.54-2.55,1.46-15.21,2.58-30.4,2.58s-27.86-1.12-30.41-2.58c-.33-.17-.48-.37-.48-.54,0-1.72,13.83-3.12,30.89-3.12S689.58,394.8,689.58,396.52Z",
    fill: "#878e99"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 657.7,
    cy: 397.18,
    rx: 27.31,
    ry: 2.45,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M553.65,99.67A77.66,77.66,0,0,0,500,233.47l-11.06,20.64,27.17-8.8A77.67,77.67,0,1,0,553.65,99.67Z",
    fill: "#28d3d3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M550,94.13a77.67,77.67,0,0,0-53.68,133.8l-11.05,20.63,27.16-8.79A77.68,77.68,0,1,0,550,94.13Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M550,250.16a78.6,78.6,0,0,1-37.69-9.66l-26.82,8.71a.69.69,0,0,1-.74-.22.72.72,0,0,1-.08-.76l10.87-20.17a78.35,78.35,0,1,1,54.52,22.1Zm-37.61-11.07a.73.73,0,0,1,.33.08,77.15,77.15,0,1,0-15.92-11.73.65.65,0,0,1,.12.8l-10.25,19.15,25.51-8.27Z",
    fill: "#28d3d3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M524,203.82l-29.88-21.08V171.56L524,150.28v11.27L502.6,177.1,524,192.65Z",
    fill: "#878e99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M533.08,207.58,555.83,123h9.71l-22.86,84.55Z",
    fill: "#878e99"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M574.61,203.82V192.65L596.11,177l-21.5-15.44V150.28l30,21.19v11.16Z",
    fill: "#878e99"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M527.7,199.19l-29.88-21.08V166.94l29.88-21.29v11.27l-21.41,15.55L527.7,188Z",
    fill: "#28d3d3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M536.77,203l22.75-84.54h9.71L546.37,203Z",
    fill: "#28d3d3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M578.31,199.19V188l21.52-15.64-21.52-15.46V145.65l30,21.18V178Z",
    fill: "#28d3d3"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe9b49f8-e166-4e47-ac65-a2d5a59265ce)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.23,493.19a4.58,4.58,0,0,1-1.81,4.25c-6.71,5.1-29.13,27.69-52.7,113.82H129.34c21.88-64,90.47-134.21,103.1-146.78a7.41,7.41,0,0,1,4.9-2.16c6.08-.26,20.57-.28,33.17,4.68C281.18,471.23,290.51,479,292.23,493.19Z",
    fill: "#878e99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.73,468.44c0,12.29-21.5,9.44-21.5,9.44-9.22-.44-14.91,2.39-14.91,2.39-13.83,4.4-33.31,7.08-33.31,7.08a.32.32,0,0,0,0-.08,30.8,30.8,0,0,0-6.54-11.07,4.93,4.93,0,0,0-.5-.52c-14.14-14.67-40.13-13.47-40.13-13.47L272.12,441s1.63-.45,3.81-5.29c0,0,3.44-8.72,7.8-8.72h7.78s7.15-13.22,12.75-9.65a22.87,22.87,0,0,1,4.68,3.9s10.89-11.2,19.61-3c0,0,7.15,8.71,8.71,12.46a15.2,15.2,0,0,1,8.76,1.92A51.59,51.59,0,0,1,358.4,443a2.4,2.4,0,0,1,.54,1,2.36,2.36,0,0,1-.37,2.2c-4.9,6.21-13.42-1.92-13.42-1.92-5.27,1.09-13.59.66-13.59.66-3.51,7.45-13.38,12.5-13.38,12.5,11,4.82,18.63,2.62,18.63,2.62,17.67-3.23,22.33,3.55,23.51,6.77h0A7.37,7.37,0,0,1,360.73,468.44Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.67,431.07l21.94-.78s-5.44-9.64-11-8.56C323.64,421.73,318.12,422.82,312.67,431.07Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,446.24c-4.9,6.21-13.42-1.92-13.42-1.92-5.27,1.09-13.59.66-13.59.66-3.51,7.45-13.38,12.5-13.38,12.5a13.51,13.51,0,0,1-5.51-3.37s16.34-3.58,17.43-11.84c0,0,11.2,2,14.64-2.48,0,0,2.18,7.45,8.23,6.06a21.87,21.87,0,0,0,5.95-1.83l0,0A2.36,2.36,0,0,1,358.57,446.24Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.73,468.44c0,12.29-21.5,9.44-21.5,9.44-9.22-.44-14.91,2.39-14.91,2.39-13.83,4.4-33.31,7.08-33.31,7.08a.32.32,0,0,0,0-.08,28.6,28.6,0,0,0-6.54-11.07,4.93,4.93,0,0,0-.5-.52,11.21,11.21,0,0,0,2.2-1.68,1.79,1.79,0,0,1,2.14-.31c2.79,1.59,11,4.9,27.52,1.74a20.8,20.8,0,0,0,3.3-1,25.48,25.48,0,0,1,9.11-1.54s14.12.59,19.18-5.05a1.41,1.41,0,0,1,1.82-.24c2.13,1.37,7.09,3.73,11.1-.77h0A7.37,7.37,0,0,1,360.73,468.44Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.34,428.58a3.88,3.88,0,0,1-.65,2.92,10,10,0,0,1-1.82,2.26,10.63,10.63,0,0,1-5,2.67,11.51,11.51,0,0,1,1.66-2.34,26.58,26.58,0,0,1,1.89-1.93c.65-.59,1.32-1.17,2-1.73A12.12,12.12,0,0,0,289.34,428.58Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,429.62A17,17,0,0,1,307,423a16.84,16.84,0,0,1-10,6.63Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.23,493.19a4.58,4.58,0,0,1-1.81,4.25c-6.71,5.1-29.13,27.69-52.7,113.82H192.94s39.89-26.12,71-92.73c0,0,10.87-21.39,6.56-51.53C281.18,471.23,290.51,479,292.23,493.19Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.49,493.19a4.58,4.58,0,0,0,1.81,4.25c6.71,5.1,29.13,27.69,52.7,113.82H681.38c-21.88-64-90.47-134.21-103.1-146.78a7.42,7.42,0,0,0-4.91-2.16c-6.07-.26-20.56-.28-33.16,4.68C529.54,471.23,520.21,479,518.49,493.19Z",
    fill: "#878e99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.21,427H527c4.35,0,7.8,8.72,7.8,8.72,2.18,4.84,3.81,5.29,3.81,5.29l28.3,21.18s-26-1.2-40.13,13.47a4.93,4.93,0,0,0-.5.52,30.8,30.8,0,0,0-6.54,11.07.32.32,0,0,0,0,.08s-19.48-2.68-33.31-7.08c0,0-5.69-2.83-14.91-2.39,0,0-21.5,2.85-21.5-9.44a7.37,7.37,0,0,1,.39-1.57h0c1.18-3.22,5.84-10,23.51-6.77,0,0,7.67,2.2,18.63-2.62,0,0-9.87-5.05-13.38-12.5,0,0-8.32.43-13.59-.66,0,0-8.52,8.13-13.42,1.92a2.36,2.36,0,0,1-.38-2.2,2.54,2.54,0,0,1,.55-1,51.39,51.39,0,0,1,12.38-10.35,15.17,15.17,0,0,1,8.75-1.92s6.87-15.25,28.33-9.5C501.78,421.27,509.54,417.62,519.21,427Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.05,431.07l-21.94-.78s5.44-6.53,11-5.44C487.08,424.85,493.35,424.63,498.05,431.07Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.15,446.24c4.9,6.21,13.42-1.92,13.42-1.92,5.27,1.09,13.59.66,13.59.66,3.51,7.45,13.38,12.5,13.38,12.5a13.57,13.57,0,0,0,5.51-3.37s-16.34-3.58-17.43-11.84c0,0-11.2,2-14.64-2.48,0,0-2.18,7.45-8.24,6.06A21.87,21.87,0,0,1,451.8,444l0,0A2.36,2.36,0,0,0,452.15,446.24Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,468.44c0,12.29,21.5,9.44,21.5,9.44,9.22-.44,14.91,2.39,14.91,2.39,13.83,4.4,33.31,7.08,33.31,7.08a.32.32,0,0,1,0-.08,28.6,28.6,0,0,1,6.54-11.07,4.93,4.93,0,0,1,.5-.52,11.21,11.21,0,0,1-2.2-1.68,1.79,1.79,0,0,0-2.14-.31c-2.79,1.59-11,4.9-27.52,1.74a20.8,20.8,0,0,1-3.3-1,25.48,25.48,0,0,0-9.11-1.54s-14.12.59-19.18-5.05a1.41,1.41,0,0,0-1.82-.24c-2.13,1.37-7.1,3.73-11.1-.77h0A7.37,7.37,0,0,0,450,468.44Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.37,428.58a12.17,12.17,0,0,0,2,1.85c.67.56,1.33,1.14,2,1.73a26.58,26.58,0,0,1,1.89,1.93,11.51,11.51,0,0,1,1.66,2.34,10.63,10.63,0,0,1-5-2.67A10,10,0,0,1,522,431.5,3.93,3.93,0,0,1,521.37,428.58Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.7,429.62a16.84,16.84,0,0,1-10-6.63,17,17,0,0,1,10,6.63Z",
    fill: "#f7a48b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.49,493.19a4.58,4.58,0,0,0,1.81,4.25c6.71,5.1,29.13,27.69,52.7,113.82h44.78s-39.9-26.12-71-92.73c0,0-10.87-21.39-6.56-51.53C529.54,471.23,520.21,479,518.49,493.19Z",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandcoding);
export default __webpack_public_path__ + "static/media/Handcoding.3e7e5520d4727d304bba90413141a586.svg";
export { ForwardRef as ReactComponent };